import React, { useEffect, useState } from 'react'

import axios from '../../utils/axios'
import useAuth from '../../context/hook/useAuth'

export const Withdrawal = () => {

    const {user} = useAuth()

    const [withdrawal, setWithdrawal] = useState([])

    const WithdrawalCheck = async () => {
        try {
            await axios.get(`/withdrawal/detail`,
                {
                    headers:{
                        "Content-Type": "application/json",
                        "Authorization":user
                    },
                    withCredentials:true,
                }
            ).then((res)=>{
                let data = JSON.parse(res.data)
                // console.log(data)
                setWithdrawal(data)
            }).catch(err=>{
                console.log(err)
            })
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(()=>{
        WithdrawalCheck()
        // eslint-disable-next-line
    },[])

  return (
    <div>
        <div className="wallet-history">
            <div className="table-responsive">
                <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">Date &amp; Time</th>
                            <th scope="col">Coin</th>
                            <th scope="col">Amount</th>
                            <th scope="col">Fee</th>
                            <th scope="col">Network</th>
                            <th scope="col">Transaction Id</th>
                            <th scope="col">Destination Address</th>
                            <th scope="col">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            withdrawal&&withdrawal.map((item,index)=>{
                                return(
                                    <React.Fragment key={index}>
                                        
                                            <tr key={index}>
                                                <td>{item.Time}</td>
                                                <td>{item.Assets}</td>
                                                <td>{item.TotalAmount}</td>
                                                <td>{Math.abs(item.Amount - item.TotalAmount)}</td>
                                                <td>{item.Chain}</td>
                                                <td>{item.Transaction_ID}</td>
                                                <td>{item.Transfer_To}</td>
                                                <td  className={item.Status ==="Approved" ? "clr-green" : item.Status ==="Rejected" ? "clr-red" : '' }>{item.Status === 'Not Approval' ? "Pending" : item.Status }</td>
                                            </tr>
                                    </React.Fragment>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
  )
}
